export default {
  name: 'marking--descRestP',
  apiService: 'shoes',
  apiPath: '/admin/desc_rest_p',
};